import React, { useMemo } from 'react';
import NavigationStepper, {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import PatientTreatmentPageWrapper from '../../../Patient/Components/PatientTreatment/PatientTreatmentPageWrapper';
import PatientsQuestionnaires from '../../../Questionnaire/Components/PatientsQuestionnaires/PatientsQuestionnaires';
import EducationMaterials from '../../../../Components/EducationMaterials/EducationMaterials';
import { useAppContext } from '../../../../Services/AppContext';
import { QuestionnaireModule } from '../../../Questionnaire/Enums/QuestionnaireModule.enum';
import { EducationMaterialModule } from '../../../../graphql/graphql';

interface Props {
	patientId: string;
}

const HealthPlanTherapistWrapper: React.FC<Props> = ({ patientId }) => {
	const { workplaceId } = useAppContext();
	const steps: NavigationStepperItemType[] = useMemo(() => {
		return [
			{
				name: 'patientTreatment.cure.questionnaires.title',
				key: 'questionnaires',
				component: (params: NavigationStepperComponentParams) => (
					<PatientTreatmentPageWrapper patientId={patientId}>
						<PatientsQuestionnaires
							patientId={patientId}
							module={QuestionnaireModule.THERAPIST}
						/>
					</PatientTreatmentPageWrapper>
				),
			},
			{
				name: 'patientTreatment.cure.educationMaterials.title',
				key: 'educationMaterials',
				component: (params: NavigationStepperComponentParams) => (
					<PatientTreatmentPageWrapper patientId={patientId}>
						<EducationMaterials
							patientId={patientId}
							workplaceId={workplaceId}
							module={EducationMaterialModule.Therapist}
						/>
					</PatientTreatmentPageWrapper>
				),
			},
		];
	}, []);

	return (
		<NavigationStepper
			steps={steps}
			initialStepPath='questionnaires'
			canSkip={true}
			showStepNumbers={false}
		/>
	);
};

export default HealthPlanTherapistWrapper;
